import { Component, Shark, Utils } from "shark-mvc";
import moment from "moment";

import templateContent from "./export-CSV.html";
import templateMultiExportContent from "./export-CSV-multi.html";

class ExportCSVComponent extends Component {
	constructor() {
		super("exportCSVComponent");

		this.addTemplate("", templateContent);
		this.addTemplate("multiExport", templateMultiExportContent);
	}

	beforeRender () {
		this.set({
			__showExportCSVButton: true
		});
	}

	downloadToUser (content, savedFileBaseName) {
		const link = document.createElement("a");
		const csvDataBlob = new Blob([content], {encoding: "UTF-8", type: "text/csv;charset=UTF-8"}); 
		const csvUrl = URL.createObjectURL(csvDataBlob);

		link.setAttribute("href", csvUrl);
		link.setAttribute("style", "display: none;");
		link.setAttribute("download", moment().format("YYYY.MM.DD - HH.mm") + " - " + savedFileBaseName + ".csv");
		link.innerHTML= "Click Here to download";
		document.body.appendChild(link);

		link.click();
		link.remove();
	}
	
	exportHtmlTables (selector) {
		const tablesData = Array.from(document.querySelectorAll(selector)).map(table => {
			return Array.from(table.querySelectorAll("tr")).map(row => {
				return Array.from(row.querySelectorAll("td")).map(cell => cell.innerText);
			});
		});

		console.log({tablesData});

		return tablesData;
	}

	exportSingleDataSet (exportType) {
		let dataSetToExport = Utils.safp(this.get("__exportCSVMultiExportList"), "exportType", exportType);

		if (!dataSetToExport && this.get("exportMap")) {
			dataSetToExport = {
				exportMap: this.get("exportMap"),
				savedFileBaseName: this.get("savedFileBaseName"),
			};
		}
		// if (!this.get("dataSourceType") || this.get("dataSourceType") === "dataMap") {

		// 	const currMap = this.get("exportMap") || maps[activeMapIndex];
		console.log({exportType, dataSetToExport});

		if (dataSetToExport) {
			var savedFileBaseName = dataSetToExport.savedFileBaseName;
			var listToExport = this.get("listToExport");
			let currMapFields = [];
			let currMapTitles = [];
			let replaceMaps = dataSetToExport.replaceMaps || this.get("replaceMaps");

			const currMap = dataSetToExport.exportMap;
		
			for (let currField in currMap.fields) {
				currMapFields.push(currField);
				currMapTitles.push(currMap.fields[currField]);
			}
		
			console.log({currMapFields, currMapTitles});
			
			if (listToExport.length > 0) {
				let csvData = "\"" + currMapTitles.join("\";\"") + "\"\r\n" +
					listToExport.map(function (item) {
						return "\"" + currMapFields.map(function (field) {
							let value = Utils.getDeepProperty(item, field);

							if (replaceMaps) {
								for (let prop in replaceMaps) {
									if (prop === field) {
										if (Array.isArray(value)) {
											value = value.map(singleValue => {
												if (replaceMaps[prop][singleValue]) {
													return replaceMaps[prop][singleValue];
												}
												else {
													return singleValue;
												}
											});
										}
										else {
											if (replaceMaps[prop][value]) {
												value = replaceMaps[prop][value];
											}
										}
									}
								}
							}

							value = value ? value.toString().replace(/"/g, "'").replace(/<br>/g, "\n").replace(/<[^>]*>/g, "") : "";
							
							if (value === true) {
								value = "Sì";
							}
							else if (value === false) {
								value = "No";
							}
			
							return value;
						}).join("\";\"") + "\"";
					}).join("\r\n");
		
				this.downloadToUser(csvData, savedFileBaseName);
			}
			else {
				alert("Non ci sono righe da esportare!");
			}
		}
		else {
			alert("Mi spiace, non trovo i dati da esportare!");
		}
	}

	init () {
		this.set({
			activeMap: "Default",
			activeMapIndex: 0,
			listIsShippingList: true,
			listToExport: null,
			exportMaps:[
				{
					name: "Prospect",
					id: "defaultProspectFieldMap",
					fields: ["__displayIndex", "code", "name", "email", "phone", "address", "city", "province", "region", "contactSource", "contactPerson", "association", "country", "createdAt", "latestFollowUp", "notes", "profession", "sector", "status", "updatedAt", "__agentAssignmentDateLabel", "__prospectAssignedAgentName", "__agentAssignmentStatus", "__followUpList"],
					titles: ["#", "codice", "nome", "email", "telefono", "indirizzo", "città", "provincia", "regione", "origine contatto", "persona di riferimento", "association", "nazione", "creato il", "ultimo follow up", "note", "profession", "settore merceologico", "status", "ultima modifica", "assegnato il", "assegnato a", "__agentAssignmentStatus", "__followUpList"]
				},
			],
			__exportCSVMultiExportList: [],
		});
	}

	// setActiveMap (mapName) {
	// 	this.set({
	// 		activeMap: mapName,
	// 		activeMapIndex: Utils.safp(this.get("exportMaps"), "name", mapName, "index")
	// 	});
	// }

	singleCSVExportBtn_clickHandler (event, data) {
		event.preventDefault();

		if (data.exportType) {
			if (typeof Shark.activePage.prepareSingleDataSetExport === "function") {
				Shark.activePage.prepareSingleDataSetExport(data.exportType)
				.then(dataToExport => {
					if (dataToExport) {
						this.set({
							listToExport: dataToExport,
						});
					}
					this.exportSingleDataSet(data.exportType);
				});
			}
			else {
				this.exportSingleDataSet(data.exportType);
			}
		}

		return false;
	}

	exportCSVBtn_clickHandler () {
		// event.preventDefault();

		// if (data.exportType) {
		if (typeof Shark.activePage.prepareSingleDataSetExport === "function") {
			Shark.activePage.prepareSingleDataSetExport()
			.then(dataToExport => {
				if (dataToExport) {
					this.set({
						listToExport: dataToExport,
					});
				}
				this.exportSingleDataSet();
			});
		}
		else {
			this.exportSingleDataSet();
		}

		// }

		// return false;
	}
}

const exportCSVComponent = new ExportCSVComponent();

// exportCSVComponent.addMethod("old_exportCSVBtn_clickHandler", function () {
// 	const savedFileBaseName = this.get("savedFileBaseName");

// 	if (!this.get("dataSourceType") || this.get("dataSourceType") === "dataMap") {
// 		var activeMapIndex = this.get("activeMapIndex");
// 		var maps = this.get("exportMaps");
// 		var listToExport = this.get("listToExport");
// 		let currMapFields = [];
// 		let currMapTitles = [];
// 		const currMap = this.get("exportMap") || maps[activeMapIndex];
// 		let replaceMaps = this.get("replaceMaps");

// 		for (let currField in currMap.fields) {
// 			currMapFields.push(currField);
// 			currMapTitles.push(currMap.fields[currField]);
// 		}
	
// 		console.log({currMapFields, currMapTitles});
		
// 		if (listToExport.length > 0) {
// 			let csvData = "\"" + currMapTitles.join("\";\"") + "\"\r\n" +
// 				listToExport.map(function (item) {
// 					return "\"" + currMapFields.map(function (field) {
// 						let value = Utils.getDeepProperty(item, field);

// 						if (replaceMaps) {
// 							for (let prop in replaceMaps) {
// 								if (prop === field) {
// 									if (Array.isArray(value)) {
// 										value = value.map(singleValue => {
// 											if (replaceMaps[prop][singleValue]) {
// 												return replaceMaps[prop][singleValue];
// 											}
// 											else {
// 												return singleValue;
// 											}
// 										});
// 									}
// 									else {
// 										if (replaceMaps[prop][value]) {
// 											value = replaceMaps[prop][value];
// 										}
// 									}
// 								}
// 							}
// 						}

// 						value = value ? value.toString().replace(/\"/g, "'").replace(/<br>/g, "\n").replace(/<[^>]*>/g, "") : "";
						
// 						if (value === true) {
// 							value = "Sì";
// 						}
// 						else if (value === false) {
// 							value = "No";
// 						}
		
// 						return value;
// 					}).join("\";\"") + "\"";
// 				}).join("\r\n");
	
// 			this.downloadToUser(csvData, savedFileBaseName);
// 		}
// 		else {
// 			alert("Nessun dato da esportare!");
// 		}	
// 	}
// 	else {
// 		var listToExport = this.exportHtmlTables(this.get("htmlTableSelector"));

// 		if (listToExport.length > 0) {
// 			let csvData = listToExport.map(table => {
// 				return table.map(row => {
// 					return "\"" + row.join("\";\"") + "\"";
// 				}).join("\r\n");
// 			}).join("\r\n");
	
// 			this.downloadToUser(csvData, savedFileBaseName);
// 		}
// 		else {
// 			alert("Nessun dato da esportare!");
// 		}	
// 	}
// });


Shark.registerComponent(exportCSVComponent);

export default exportCSVComponent;
